parseUnionMemberTypes